import Vue from 'vue';
import Vuex from 'vuex';
import env from '../env';

const { context, modules } = loadModules()
Vue.use(Vuex);

let store = new Vuex.Store({
    modules,
    strict: process.env.NODE_ENV !== 'production'
});

store.subscribe((mutation, state) => {
    // pass mutations to form module for undo/redo
    if (mutation.type.startsWith('form/')) {
        store.dispatch('form/onMutation', { type: mutation.type.slice(5), payload: mutation.payload });
    }
});

if (module.hot) {
    // Hot reload whenever any module changes.
    module.hot.accept(context.id, () => {
        const { modules } = loadModules()

        store.hotUpdate({
            modules
        })
    })
}

function loadModules() {
    const context = require.context('./modules', false, /\.store\.js$/);
    const modules = {};

    // import all .store.js modules as eg: session.store.js => session
    context.keys().forEach(filename => {
        const moduleName = filename.replace(/(\.\/|\.store\.js)/g, '');
        modules[moduleName] = context(filename).default || context(filename);
    });

    return { context, modules }
}

env.onLoad(() => {
    store.commit('base/domain', env.PAPERWORK_DOMAIN);
    store.commit('base/subdomain', env.PAPERWORK_DEFAULT_SUBDOMAIN);
    store.commit('base/envLoaded', true);
});

export default store;